var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PosAngleData = require("../abstract/posAngleData.js");
var WidthHeightData = require("../abstract/widthHeightData.js");
// var PathData = require("./pathData.js");
var SVGToMesh = require("./../threejsExport/svgToMesh.js");
var cio_config = require("cio-config");

var RectangleData = function (center, angle, width, height, fill, strokeWidth, color, rx, ry) {
    this.makeObservableTreeNode();

    this.addPosAngle(center, angle);
    this.addWidthHeight(width, height);

    this.rx = this.value("rx", true, cio_config.types.positive_float.validator);
    this.ry = this.value("ry", true, cio_config.types.positive_float.validator);

    this.fill = this.value("fill", true, cio_config.types.any.validator);
    this.strokeWidth = this.value("strokeWidth", true, cio_config.types.float.validator);
    this.color = this.value("color", true, cio_config.types.any.validator);     // if color == null, color is inherited from parent layer

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [this.pos, this.angle, this.width, this.height, this.rx, this.ry]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.geometry]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return RectangleData.calculateBoundingBox(this.pos().x, this.pos().y, this.width(), this.height(), this.angle());
        },
        [this.height, this.width, this.angle, this.pos]
    );


    SVGToMesh.call(this);

    if (fill != undefined) this.fill(fill);
    if (strokeWidth != undefined) this.strokeWidth(strokeWidth);
    if (color != undefined) this.color(color);
    if (rx != undefined) this.rx(rx);
    else this.rx(0);
    if (ry != undefined) this.ry(ry);
    else this.ry(0);
};
lib_core.mixin(RectangleData, lib_core.ObservableTreeNode);
lib_core.mixin(RectangleData, PosAngleData);
lib_core.mixin(RectangleData, WidthHeightData);

module.exports = RectangleData;

lib_core.JsonParser.registerClass(RectangleData, "RectangleData");

RectangleData.prototype.lowerLeftPos = function (){
    return new lib_geometry.Coord(this.pos().x-this.width()/2, this.pos().y-this.height()/2);
};

RectangleData.prototype.getVertices = function (){
    return [
        (new lib_geometry.Coord(this.pos().x-this.width()/2, this.pos().y-this.height()/2).rotate(this.angle(), this.pos())),
        (new lib_geometry.Coord(this.pos().x+this.width()/2, this.pos().y-this.height()/2).rotate(this.angle(), this.pos())),
        (new lib_geometry.Coord(this.pos().x+this.width()/2, this.pos().y+this.height()/2).rotate(this.angle(), this.pos())),
        (new lib_geometry.Coord(this.pos().x-this.width()/2, this.pos().y+this.height()/2).rotate(this.angle(), this.pos()))
    ];
};

RectangleData.prototype._getGeometry = function() {
    var pos = this.lowerLeftPos();
    var x = pos.getX();
    var y = pos.getY();
    var w = this.width();
    var h = this.height();
    var rx = (this.rx() > this.width()/2)? this.width()/2 : this.rx();
    var ry = (this.ry() > this.height()/2)? this.height()/2 : this.ry();
 
    var path = new lib_geometry.Path();

    if(rx){
        if(!ry) ry = rx;
         path
          .moveTo(x+rx, y)
          .lineTo(w-rx*2, 0, true)
          .arcTo(rx, ry, 0, 0, 1, rx, ry, true)
          .lineTo(0, h-ry*2, true)
          .arcTo(rx, ry, 0, 0, 1, -rx, ry, true)
          .lineTo(rx*2 - w, 0, true)
          .arcTo(rx, ry, 0, 0, 1, -rx, -ry, true)
          .lineTo(0, ry*2 -h, true)
          .arcTo(rx, ry, 0, 0, 1, rx, -ry, true)
          .close();
    } else {
        path
         .moveTo(x, y)
         .lineTo(w, 0, true)
         .lineTo(0, h, true)
         .lineTo(-w, 0, true)
         .close();
    }

    path = path.rotate(this.angle(), this.pos());
    path.fill(this.fill());
    return path;
};

RectangleData.prototype._getSegmentedGeometry = function (precision) {
    return this.geometry().toSegmented(precision);
};

 
// TODO: is this used anywhere?
// RectangleData.prototype.expand = function(dest, precision) {
//     var memberName = this.ownerMember._name();
//     var geometryPath = this.segmentedGeometry(precision).toPath();
//     var destination = dest || this.parent(); // if no destination is given, expand in own parent
//     if (!dest) this.remove();   // if expanding in own parent, first remove original generator

//     var path = new PathData(destination.root);
//     path.fromGeometryPath(geometryPath);
//     destination.getMemberByName(memberName).push(path);
// };

RectangleData.calculateBoundingBox = function (cx, cy, width, height, angle) {
    var c = new lib_geometry.Coord(cx, cy);
    var p1 = new lib_geometry.Coord(cx-width/2, cy-height/2);
    var p2 = new lib_geometry.Coord(cx-width/2, cy+height/2);
    var p3 = new lib_geometry.Coord(cx+width/2, cy-height/2);
    var p4 = new lib_geometry.Coord(cx+width/2, cy+height/2);
    var pointSet = new lib_geometry.PointSet([p1, p2, p3, p4]);
    pointSet = pointSet.rotate(angle, c);
    return pointSet.getBB();
};
